import {fetchGet, fetchPost} from "../../requests/NetworkRequestAuth0";
import {uri} from "./AppRequest";

export const findDancerDances = (
    venueId,
    dancerId,
    successMethod,
    errorMethod,
    getAccessTokenSilently
) => {
    fetchGet(
        uri + "/venue/" + venueId + "/dancer/" + dancerId + "/dance",
        successMethod,
        errorMethod,
        getAccessTokenSilently);
};

export const sellDance = (
    venueId,
    userCode,
    adminCode,
    packageId,
    dancerCode,
    dancerId,
    successMethod,
    errorMethod,
    getAccessTokenSilently
) => {
    const params = {
        userCode: userCode,
        adminCode: adminCode,
        packageId: packageId,
        dancerCode: dancerCode,
        dancerId: dancerId
    };
    fetchPost(
        uri + "/venue/" + venueId + "/dance",
        successMethod,
        errorMethod,
        params,
        getAccessTokenSilently);
};

export const revertDance = (
    venueId,
    dancerId,
    danceId,
    adminCode,
    successMethod,
    errorMethod,
    getAccessTokenSilently
) => {
    const params = {
        venueId: venueId,
        dancerId: dancerId,
        danceId: danceId,
        adminCode: adminCode
    };
    fetchPost(
        uri + "/venue/" + venueId + "/dance/pay/revert",
        successMethod,
        errorMethod,
        params,
        getAccessTokenSilently);
};